// extracted by mini-css-extract-plugin
export default {"pageWrap":"Oe-z","fullWidth":"Pe-z","heading":"Qe-z","fullBleed":"Re-z","hidden":"Se-z"};